<div class="login-body">
    <div class="login-panel p-fluid">
        <p-messages [(value)]="errorMessages" [closable]="false"></p-messages>
        <div class="p-grid login-container" style="padding-bottom: 20px;">
            <div class="p-col-12 logo-container">
                <img src="assets/title_logo.png" class="morpheus-logo" />
            </div>
            <div class="p-col-12">
                <input type="text" autocomplete="off" class="p-inputtext p-corner-all p-state-default p-widget" [(ngModel)]="confirmationCode"
                    placeholder="Confirmation Code">
            </div>
            <div class="p-col-12 button-container">
                <button type="button" (click)="onConfirmRegistration()" class="p-button blue-btn raised-btn p-widget p-state-default p-corner-all p-button-text-icon-left">
                        <span class="p-button-text p-c">Confirm</span>
                    </button>
            </div>
        </div>
        <div class="stripe"></div>
        <p style="margin-left: -17px;">Can't find your code? <a [routerLink]="['/resendCode']"> Resend </a></p>
        <div class="stripe"></div>
    </div>
</div>
